import PageContainer from '@/common/components/PageContainer'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import PlayerDetail from '@/modules/manage-player/components/PlayerDetail'

function PlayerDetailPage() {
	return (
		<PageContainer>
			<PlayerDetail />
		</PageContainer>
	)
}

const GuardedPlayerDetailPage = withUserPermission(PlayerDetailPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedPlayerDetailPage
